import { render, staticRenderFns } from "./DashboardChannelStockStatus.vue?vue&type=template&id=57ad432c&scoped=true&"
import script from "./DashboardChannelStockStatus.vue?vue&type=script&lang=js&"
export * from "./DashboardChannelStockStatus.vue?vue&type=script&lang=js&"
import style0 from "./DashboardChannelStockStatus.vue?vue&type=style&index=0&id=57ad432c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ad432c",
  null
  
)

export default component.exports